import { Routes } from '@angular/router';
import { authGuard } from './guards/authGuard';
import { publicGuard } from './guards/publicGuard';
import { adminRoleGuard } from './guards/adminRoleGuard';

export const routes: Routes = [
    {
        path: "login",
        loadComponent: () => import("./pages/login-page/login-page.component"),
        canActivate: [publicGuard],
        children: [
            {
                path: "",
                loadComponent: () => import("./components/login/login-form/login-form.component"),          
            },
            {
                path: "sign-up",
                loadComponent: () => import("./components/login/sign-up/sign-up.component"),          
            },
            {
                path: "forgot-password",
                loadComponent: () => import("./components/login/forgot-password/forgot-password.component"),          
            },
            {
                path: "new-password",
                loadComponent: () => import("./components/login/new-password/new-password.component"),          
            },
            {
                path: "confirm",
                loadComponent: () => import("./components/login/confirm-user/confirm-user.component"),          
            },
            {
                path: '**',
                redirectTo: '/login',
                pathMatch: 'full',
            },
        ]
    }, {
        
        path: "",
        loadComponent: () => import("./pages/main-page/main-page.component"),
        canActivate: [authGuard],
        children: [
            {
              path: "",
              loadComponent: () => import("./pages/censuses-page/censuses-page.component"),
            },
            {
              path: "census-detail/user/:id",
              loadComponent: () => import("./pages/censuses-user-page/censuses-user-page.component"),
            },
            {
                path: "new-censuse",
                loadComponent: () => import("./pages/add-censuse/add-censuse.component"),
            },
            {
                path: "census-detail/:id/outcome",
                loadComponent: () => import("./pages/census-outcome/census-outcome.component"),
            },
            {
                path: "census-detail/:id",
                loadComponent: () => import("./pages/census-detail-page/census-detail-page.component"),
            },
            {
                path: "census-detail/:id/update",
                loadComponent: () => import("./pages/add-censuse/add-censuse.component"),
            },
            {
                path: "profile",
                loadComponent: () => import("./pages/profile/profile.component"),
            },
            {
                path: "users",
                loadComponent: () => import("./pages/router-page/router-page.component"),
                canActivate: [adminRoleGuard],

                children: [
                    {
                        path: "",
                        loadComponent: () => import("./pages/users-page/users-page.component"),        
                    }, 
                    {
                        path: "new",
                        loadComponent: () => import("./pages/add-user/add-user.component"),        
                    },
                    {
                        path: "update/:id",
                        loadComponent: () => import("./pages/add-user/add-user.component"),        
                    },
                ]
            },
        ]
    },
];
